import initVueApp from "@/core.js";
const component = require(`./../views/Landing.vue`).default;
initVueApp(component);
